(() => {
  if (customElements.get('coin-animation')) {
    return;
  }

  class CoinAnimation extends HTMLElement {
    constructor() {
      super();
      this.coin = this.querySelector('.icon-coin');
    }

    connectedCallback() {
      document.addEventListener('scroll', this.onScroll.bind(this))
    }

    onScroll () {
      var position = this.closest('section').getBoundingClientRect();

      if(position.top <= 0) {
        this.coin.classList.add('animate');
      } else {
        this.coin.classList.remove('animate');
      }
    }
  }

  customElements.define('coin-animation', CoinAnimation);
})();